module.exports = __webpack_public_path__ + "img/蒙版组 134.bda5918d.png";